import maintenance from "./components/Main.vue";

export default [
  { path: "/maintenance", name: "maintenance", component: maintenance },
];
